import type { createWorkerClient, WagerWorkerMessageMap } from '../../../lib/entry.browser.js';

function throwWorkerNotInitialized(): never {
  throw new Error('Worker not initialized');
}

function noop(): void {
  // no-op
}

function noopUnsubscribe(): void {
  // no-op
}

function noopSubscribe(): () => void {
  return noopUnsubscribe;
}

export const defaultWorker: ReturnType<typeof createWorkerClient<WagerWorkerMessageMap>> = {
  post: throwWorkerNotInitialized,
  terminate: noop,
  subscribe: noopSubscribe,
};
